import { css as p, LitElement as u, html as g } from "lit";
import { property as i, customElement as d } from "lit/decorators.js";
import { classMap as h } from "lit/directives/class-map.js";
import { b as f } from "./styles-scZ6dVz-.js";
var v = Object.defineProperty, b = Object.getOwnPropertyDescriptor, o = (a, s, n, e) => {
  for (var r = e > 1 ? void 0 : e ? b(s, n) : s, l = a.length - 1, c; l >= 0; l--)
    (c = a[l]) && (r = (e ? c(s, n, r) : c(r)) || r);
  return e && r && v(s, n, r), r;
};
let t = class extends u {
  constructor() {
    super(...arguments), this.variant = "default", this.size = "md", this.pulse = !1, this.ring = !1;
  }
  render() {
    const a = {
      dot: !0,
      [this.variant]: !0,
      [this.size]: !0,
      pulse: this.pulse,
      ring: this.ring
    };
    return g`
      <span
        part="dot"
        class=${h(a)}
        role="status"
        aria-label=${this.variant}
      ></span>
    `;
  }
};
t.styles = [
  f,
  p`
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .dot {
        border-radius: var(--r5-radius-full);
        flex-shrink: 0;
      }

      /* Sizes */
      .xs {
        width: 6px;
        height: 6px;
      }

      .sm {
        width: 8px;
        height: 8px;
      }

      .md {
        width: 10px;
        height: 10px;
      }

      .lg {
        width: 12px;
        height: 12px;
      }

      /* Variants */
      .default {
        background-color: var(--ark-status-dot-color, var(--r5-color-primary-500));
      }

      .success {
        background-color: var(--ark-status-dot-color, var(--r5-color-success-500));
      }

      .warning {
        background-color: var(--ark-status-dot-color, var(--r5-color-warning-500));
      }

      .danger {
        background-color: var(--ark-status-dot-color, var(--r5-color-danger-500));
      }

      .info {
        background-color: var(--ark-status-dot-color, var(--r5-color-info-500));
      }

      .neutral {
        background-color: var(--ark-status-dot-color, var(--r5-text-muted));
      }

      /* Pulse animation */
      .pulse {
        animation: ark-status-dot-pulse 2s ease-in-out infinite;
      }

      @keyframes ark-status-dot-pulse {
        0%, 100% {
          opacity: 1;
          transform: scale(1);
        }
        50% {
          opacity: 0.6;
          transform: scale(1.1);
        }
      }

      /* With ring */
      .ring {
        box-shadow: 0 0 0 3px var(--ark-status-dot-ring-color, rgba(0, 0, 0, 0.1));
      }

      .success.ring {
        box-shadow: 0 0 0 3px rgba(var(--r5-color-success-500-rgb, 34, 197, 94), 0.2);
      }

      .warning.ring {
        box-shadow: 0 0 0 3px rgba(var(--r5-color-warning-500-rgb, 234, 179, 8), 0.2);
      }

      .danger.ring {
        box-shadow: 0 0 0 3px rgba(var(--r5-color-danger-500-rgb, 239, 68, 68), 0.2);
      }

      .info.ring {
        box-shadow: 0 0 0 3px rgba(var(--r5-color-info-500-rgb, 59, 130, 246), 0.2);
      }
    `
];
o([
  i({ type: String, reflect: !0 })
], t.prototype, "variant", 2);
o([
  i({ type: String, reflect: !0 })
], t.prototype, "size", 2);
o([
  i({ type: Boolean, reflect: !0 })
], t.prototype, "pulse", 2);
o([
  i({ type: Boolean, reflect: !0 })
], t.prototype, "ring", 2);
t = o([
  d("ark-status-dot")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-status-dot-1QrSpBdV.js.map
